import React from "react";
import { motion } from "framer-motion";
import { Waves, Sun, Wifi, WashingMachine, ChefHat, Refrigerator, Coffee, ArrowUpFromLine, Tv, Flame, HandPlatter, Cigarette } from "lucide-react";

const AMENITIES = [
    { icon: Waves, label: "Communal pool", note: "Sun-drenched, steps away" },
    { icon: Sun, label: "Private balcony", note: "Morning coffee spot" },
    { icon: Wifi, label: "Free Wi-Fi", note: "Fast & reliable" },
    { icon: WashingMachine, label: "Washer & dryer", note: "In-unit laundry" },
    { icon: ChefHat, label: "Kitchen & oven", note: "Fully equipped" },
    { icon: Refrigerator, label: "Refrigerator", note: "Full-size" },
    { icon: Coffee, label: "Coffee maker", note: "Slow island mornings" },
    { icon: ArrowUpFromLine, label: "Elevator", note: "Easy access" },
    { icon: Tv, label: "TV", note: "Movie nights in" },
    { icon: Flame, label: "Heating", note: "Year-round comfort" },
    { icon: HandPlatter, label: "Towels provided", note: "Beach & bath" },
    { icon: Cigarette, label: "Smoke-free", note: "Fresh coastal air" },
];

export default function Amenities() {
    return (
        <section id="amenities" className="py-24 lg:py-36 bg-[#F3EDE2]" data-testid="amenities-section">
            <div className="max-w-7xl mx-auto px-5 lg:px-8">
                <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="max-w-2xl mb-14">
                    <p className="text-xs uppercase tracking-[0.3em] text-[#C49A45] font-semibold">What this stay includes</p>
                    <h2 className="font-serif-d font-light text-4xl sm:text-5xl lg:text-6xl text-[#0F2837] mt-4 leading-[1.05]">
                        Every detail, <em className="text-[#2D6A76]">considered.</em>
                    </h2>
                </motion.div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-testid="amenities-grid">
                    {AMENITIES.map(({ icon: Icon, label, note }, i) => (
                        <motion.div key={label}
                            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.6, delay: (i % 4) * 0.06 }}
                            className="rounded-3xl bg-white border border-[#E5DCCB] p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
                            data-testid={`amenity-card-${i}`}>
                            <div className="w-11 h-11 rounded-2xl bg-[#F3EDE2] flex items-center justify-center group-hover:bg-[#0F2837] transition-colors duration-300">
                                <Icon size={20} className="text-[#C49A45]" />
                            </div>
                            <p className="mt-4 font-semibold text-[#0F2837] text-sm">{label}</p>
                            <p className="text-xs text-[#5C6A78] mt-1">{note}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
